import React from 'react'

const SvgComponent = props => (
  <svg viewBox="0 0 448 328" {...props}>
    <defs>
      <linearGradient
        x1="75.439%"
        y1="17.436%"
        x2="41.317%"
        y2="70.846%"
        id="dwarves__prefix__a"
      >
        <stop stopColor="#FCB6C4" offset="0%" />
        <stop stopColor="#FDBBCA" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="33.886%"
        y1="27.798%"
        x2="150.287%"
        y2="88.015%"
        id="dwarves__prefix__b"
      >
        <stop stopColor="#FDB7C5" offset="0%" />
        <stop stopColor="#F67F99" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="dwarves__prefix__c"
      >
        <stop stopColor="#F6B4C2" offset="0%" />
        <stop stopColor="#F6708E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="0%"
        y1="50%"
        x2="100%"
        y2="50%"
        id="dwarves__prefix__d"
      >
        <stop stopColor="#FEECEF" offset="0%" />
        <stop stopColor="#FCD3DB" offset="100%" />
      </linearGradient>
      <linearGradient
        x1=".172%"
        y1="49.911%"
        x2="100.097%"
        y2="49.911%"
        id="dwarves__prefix__e"
      >
        <stop stopColor="#E36579" offset="0%" />
        <stop stopColor="#E13F5E" offset="47.59%" />
      </linearGradient>
      <linearGradient
        x1=".185%"
        y1="52.242%"
        x2="99.902%"
        y2="52.242%"
        id="dwarves__prefix__f"
      >
        <stop stopColor="#E36579" offset="0%" />
        <stop stopColor="#E13F5E" offset="47.59%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M387.404 190.578c.795-2.69.795-4.61 0-5.763-1.19-1.728-2.382-2.304-2.382-6.338 0-4.034 1.588-5.186-1.191-8.067-2.78-2.881 2.512-5.348-4.339-11.717-6.85-6.368-1.62-12.357-16.61-16.064-9.993-2.472-19.024.066-27.093 7.613-3.177 1.152-5.427 5.762-6.75 13.83-1.985 12.1.397 21.896-3.97 26.506-2.912 3.073 17.866 3.073 62.335 0zM112.265 190.578c.713-2.69.713-4.61 0-5.763-1.07-1.728-2.141-2.304-2.141-6.338 0-4.034 7.974-9.897 5.476-12.778-2.498-2.88 2.821-6.424-3.335-12.792-6.157-6.368-7.465-6.796-17.465-9.994-10-3.198-19.2 0-24.4 3.198-5.2 3.198-8.806 5.86-10.59 17.96-1.785 12.101.356 21.897-3.569 26.507-2.617 3.073 16.058 3.073 56.024 0z"
        fill="#FA8199"
      />
      <path
        d="M0 265.241c0-43.591 35.613-78.955 79.6-78.955 43.987 0 79.6 35.364 79.6 78.955v37.115c0 5.252-3.757 9.453-8.453 9.453H27.394C12.288 311.81 0 298.067 0 281.173V265.24z"
        fill="url(#dwarves__prefix__a)"
        fillRule="nonzero"
        transform="translate(0 1)"
      />
      <path
        d="M280.8 263.165c0-45.535 37.402-82.476 83.6-82.476 46.198 0 83.6 36.94 83.6 82.476v38.77c0 5.485-3.946 9.874-8.878 9.874H309.571c-15.865 0-28.771-14.355-28.771-32.002v-16.642z"
        fill="url(#dwarves__prefix__b)"
        fillRule="nonzero"
        transform="matrix(-1 0 0 1 728.8 1)"
      />
      <path
        d="M340.8 276.432l58.8-7.196c.267-6.396-.267-13.192-1.6-20.388"
        stroke="#E98699"
        strokeWidth={0.8}
        opacity={0.589}
      />
      <path d="M341.2 276.831v35.179" stroke="#E98699" strokeWidth={0.8} />
      <path
        d="M310.579 306.048l-1.072 2.013a6.402 6.402 0 0 1-8.656 2.647 6.396 6.396 0 0 1-2.645-8.652l9.016-16.947a12.767 12.767 0 0 1 1.526-2.868l.723-1.36a6.402 6.402 0 0 1 5.68-3.396 12.787 12.787 0 0 1 4.049-.654H340a.8.8 0 0 1 .8.8v33.579a.8.8 0 0 1-.8.8h-16.4a17.16 17.16 0 0 1-13.021-5.962z"
        fill="#FCCCD5"
      />
      <path
        d="M129.6 260.883c0-46.924 38.476-84.99 86-84.99s86 38.066 86 84.99v19.632c0 18.704-13.16 30.495-18.233 30.495h-124.17c-16.32 0-29.597-14.793-29.597-32.979v-17.148z"
        fill="url(#dwarves__prefix__c)"
        fillRule="nonzero"
        transform="translate(0 1)"
      />
      <g fillRule="nonzero">
        <path
          d="M88.4 224.863c13.843 0 23.505-13.687 23.505-30.48l1.695-24.673c0-16.735-11.357-26.397-25.2-26.397s-25.2 9.662-25.2 26.397l2.543 24.672c0 16.794 8.814 30.481 22.657 30.481z"
          fill="#F98098"
        />
        <path
          d="M91.2 197.68c7.917 0 14.4-6.477 14.4-14.388v-17.597c0-7.91-6.483-14.387-14.4-14.387-7.917 0-14.4 6.477-14.4 14.387v17.597c0 7.91 6.483 14.388 14.4 14.388z"
          fill="#FFEBEE"
        />
        <path
          d="M105.15 183.297s2.813 7.895 0 15.268c-2.813 7.373-18 9.985-23.738 6.154-5.737-3.774-4.5-21.422-4.5-21.422l15.694-4.006 12.544 4.006zM84.8 151.4s13.123 8.662 23.165 12.7c0 0 .97-9.305-7.303-12.875-8.33-3.51-15.862.176-15.862.176z"
          fill="#F98098"
        />
        <path
          d="M108 172.095c2.192 0 4 1.807 4 3.998 0 2.19-1.808 3.997-4 3.997v-7.995zM74.4 180.89a4.783 4.783 0 0 1-4.8-4.797 4.783 4.783 0 0 1 4.8-4.797v9.594z"
          fill="#FDE7EC"
        />
        <path
          d="M83.664 224.863l10.269.455s2.76 9.554-5.135 13.137c0 0-7.508-.569-5.134-13.592z"
          fill="#F98098"
        />
        <path fill="#E13F5E" d="M82.79 226.462h11.163l1.247-3.198H81.6z" />
        <path
          d="M92.592 176.478s10.566-6.696 12.217 9.59c0 0-9.08-2.48-13.125-5.457 0 0-9.658 6.448-15.519 4.63 0 .082 4.293-14.798 16.427-8.763z"
          fill="#ED6681"
        />
      </g>
      <g fillRule="nonzero">
        <path
          d="M331.322 187.24V165.3c0-13.45 9.372-20.388 22.25-20.388 12.877 0 22.25 7.136 22.25 27.015l2.02 16.246c2.789 23.64-3.9 39.41-22.91 39.41-33.44 0-23.61-26.846-23.61-40.343z"
          fill="#F98098"
        />
        <path
          d="M350.62 194.462c-8.522 0-15.5-6.058-15.5-13.456v-17.274c0-7.398 6.978-12.639 15.5-12.639 8.523 0 15.501 5.241 15.501 12.64v17.273c0 7.398-6.978 13.456-15.5 13.456z"
          fill="#FFEBEE"
        />
        <path
          d="M334.062 171.408c0-4.559-1.632 14.732 1.431 20.128 3.063 5.396 20.768 4.682 27.016 1.878 6.248-2.762 3.83-22.006 3.83-22.006l-.536 1.55a11.298 11.298 0 0 1-11.532 7.566c-3.404-.259-11.707.016-12.125 0-4.435-.173-7.13-3.211-8.084-9.116z"
          fill="#F98098"
        />
        <path
          d="M369.886 182.29c2.423 0 4.318-1.985 4.318-4.399 0-2.468-1.948-4.4-4.318-4.4v8.8z"
          fill="#FDE7EC"
        />
        <path
          d="M348.482 179.28s-10.556-8.703-12.205 12.463c0 0 9.071-3.223 13.112-7.091 0 0 9.648 8.38 15.503 6.017 0 .107-4.288-19.233-16.41-11.39z"
          fill="#ED6681"
        />
      </g>
      <g fillRule="nonzero">
        <path
          d="M216.534 196.387c13.792 0 26.207-12.345 27.56-24.756v-8.23c-1.764-10.868-6.291-27.284-26.048-27.284-19.756 0-27.576 10.996-29.945 27.285v8.23c1.258 12.41 14.64 24.755 28.433 24.755z"
          fill="#F98098"
        />
        <path
          d="M215.42 191.05c7.81 0 14.205-6.352 14.205-14.109v-17.257c0-7.757-6.395-14.11-14.205-14.11-7.81 0-14.206 6.353-14.206 14.11v17.257c0 7.757 6.396 14.11 14.206 14.11z"
          fill="#FFEBEE"
        />
        <path
          d="M229.691 176.481s2.825 7.657 0 14.807-18.08 9.684-23.844 5.968c-5.763-3.66-4.52-20.775-4.52-20.775l15.764-3.885 12.6 3.885z"
          fill="#F98098"
        />
        <path
          d="M200.348 145.075s6.932 14.104 29.981 14.104c0 0 6.842-10.84-5.78-14.273-12.71-3.377-24.201.169-24.201.169z"
          fill="#FA8199"
        />
        <path
          d="M232.43 165.347c2.173 0 3.965 1.787 3.965 3.954 0 2.167-1.792 3.954-3.964 3.954v-7.908zM198.734 173.915a4.604 4.604 0 0 1-4.625-4.614 4.604 4.604 0 0 1 4.625-4.613v9.227z"
          fill="#FDE7EC"
        />
        <path
          d="M201.568 211.122l8.064.382s2.167 8.015-4.032 11.02c0 0-5.896-.476-4.032-11.402z"
          fill="#F98098"
        />
        <path
          d="M198.701 181.727c3.665-2.444 9.427 1.629 17.287 12.217 0 0-1.863 18.839-11.066 18.839-7.261 0-11.717-27.391-6.22-31.056z"
          fill="#F98098"
        />
        <path
          fill="#E13F5E"
          d="M201.171 212.714h8.556l1.03-3.296-10.25-.407z"
        />
        <g>
          <path
            d="M230.409 211.122l-8.064.382s-2.168 8.015 4.032 11.02c0 0 5.896-.476 4.032-11.402z"
            fill="#F98098"
          />
          <path
            d="M233.275 181.727c-3.664-2.444-9.426 1.629-17.287 12.217 0 0 1.864 18.839 11.067 18.839 7.26 0 11.717-27.391 6.22-31.056z"
            fill="#F98098"
          />
          <path
            fill="#E13F5E"
            d="M229.78 211.862h-6.588l-.793-2.537 7.891-.314z"
          />
        </g>
        <g fill="#ED6681">
          <path d="M216.675 172.311s17.424-9.366 15.73 16.073c0 0-11.066-2.227-15.73-9.282 0 0-4.39 7.876-18.599 7.876 0 .14 1.381-23.793 18.6-14.667z" />
        </g>
      </g>
      <path
        d="M344 150.233s5.575 11.469 24.111 11.469c0 0 5.503-8.815-4.649-11.607-10.22-2.746-19.462.138-19.462.138z"
        fill="#FA8199"
        fillRule="nonzero"
      />
      <g fillRule="nonzero">
        <path
          d="M254.932 114.903c.721 17.54 18.892 30.946 40.606 30.079 21.713-.934 38.77-15.873 38.048-33.347-.722-17.474-18.893-30.947-40.607-30.08-21.713.867-38.769 15.807-38.047 33.348z"
          fill="#FCEBF0"
        />
        <path
          d="M260.688 110.964c0-18.341 19.024-33.28 42.508-33.28 23.485 0 42.509 14.872 42.509 33.28 0 18.34-19.024 33.28-42.509 33.28-5.97 0-11.676-1-16.859-2.734-2.164 2.2-10.955 5.402-17.843 2.868 0 0 2.952-.2 4.789-3.202 1.837-3.001 1.771-5.269 1.771-5.269-8.79-6.135-14.366-15.006-14.366-24.943zM204.754 56.364c0-30.511-30.522-55.364-68.2-55.364-37.68 0-68.201 24.742-68.201 55.364 0 30.51 30.522 55.363 68.2 55.363a82.646 82.646 0 0 0 27.05-4.549c3.472 3.662 17.576 8.987 28.627 4.771 0 0-4.737-.333-7.683-5.325-2.947-4.993-2.842-8.765-2.842-8.765 14.103-10.208 23.05-24.964 23.05-41.495z"
          stroke="#E98699"
          strokeWidth={0.8}
          fill="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M36.8 18.152c0 4.898-1.968 9.342-5.165 12.602a16.564 16.564 0 0 0-4.519 9.038c-.23 1.456-1.506 2.532-3.013 2.532h-11.42c-1.492 0-2.783-1.061-2.998-2.517-.538-3.382-2.121-6.596-4.55-9.068C2 27.524.047 23.157.001 18.349-.107 8.25 8.041.076 18.278.001 28.499-.075 36.8 8.083 36.8 18.152z"
        fill="url(#dwarves__prefix__c)"
        fillRule="nonzero"
        transform="translate(119.2 32.18)"
      />
      <path
        d="M130.175 77.801h14.869M130.175 82.117h14.869"
        stroke="#E98699"
        strokeWidth={3.2}
        strokeLinecap="square"
      />
      <g fill="#E13F5E" fillRule="nonzero">
        <path d="M145.333 51.434a1.053 1.053 0 0 0-.703-.751l-5.243-1.71 3.724-7.284a1.033 1.033 0 0 0-.33-1.316 1.086 1.086 0 0 0-1.382.11l-10.686 10.452c-.262.256-.37.626-.285.979.086.353.351.637.703.75l5.243 1.71-3.724 7.284a1.033 1.033 0 0 0 .33 1.316 1.087 1.087 0 0 0 1.382-.109l10.686-10.452c.262-.256.37-.627.285-.98z" />
      </g>
      <g fillRule="nonzero">
        <path
          d="M270.596 327.673H161.339a1.763 1.763 0 0 1-1.776-1.764c0-.98.789-1.765 1.776-1.765h109.257c.986 0 1.776.784 1.776 1.765 0 .915-.79 1.764-1.776 1.764z"
          fill="#F2D5D2"
        />
        <path
          d="M111.56 78.951H6.774c-3.683 0-6.71-2.941-6.71-6.666V6.862c0-3.66 2.96-6.666 6.71-6.666H111.56c3.684 0 6.71 2.941 6.71 6.666V72.35a6.703 6.703 0 0 1-6.71 6.601z"
          fill="url(#dwarves__prefix__d)"
          transform="translate(156.8 245.65)"
        />
        <path
          d="M221.657 284.08c0-2.614 2.17-3.856 2.236-3.921-1.25-1.765-3.157-2.026-3.815-2.026-1.644-.131-3.157.98-4.012.98-.79 0-2.105-.915-3.42-.915-1.777 0-3.421 1.046-4.276 2.614-1.842 3.137-.46 7.843 1.315 10.392.855 1.242 1.908 2.68 3.29 2.614 1.315-.065 1.841-.85 3.42-.85 1.578 0 2.039.85 3.42.85 1.447 0 2.302-1.307 3.157-2.549.987-1.437 1.382-2.875 1.448-2.94 0-.131-2.763-1.177-2.763-4.249zm-2.631-7.712c.723-.85 1.184-2.091 1.052-3.333-1.052.065-2.302.719-3.091 1.568-.658.785-1.25 2.027-1.119 3.203 1.184.13 2.434-.523 3.158-1.438z"
          fill="#FFF"
        />
      </g>
      <g>
        <path
          d="M84 276.432l-44.75-7.196c-.202-6.396.204-13.192 1.218-20.388"
          stroke="#E98699"
          strokeWidth={0.8}
          opacity={0.589}
        />
        <path d="M83.6 276.831v35.179" stroke="#E98699" strokeWidth={0.8} />
        <path
          d="M114.221 306.048l1.072 2.013a6.402 6.402 0 0 0 8.656 2.647 6.396 6.396 0 0 0 2.645-8.652l-9.016-16.947a12.767 12.767 0 0 0-1.526-2.868l-.723-1.36a6.402 6.402 0 0 0-5.68-3.396 12.787 12.787 0 0 0-4.049-.654H84.8a.8.8 0 0 0-.8.8v33.579a.8.8 0 0 0 .8.8h16.4a17.16 17.16 0 0 0 13.021-5.962z"
          fill="#FCCCD5"
        />
      </g>
      <g fillRule="nonzero">
        <g
          fill="#1A1C3A"
          stroke="#E3536C"
          strokeLinejoin="round"
          strokeWidth={0.8}
        >
          <path d="M141.004 280.292a18.533 18.533 0 0 0-13.895 5.454c-3.85 3.877-5.611 8.937-5.415 13.997l19.31-19.45zM121.759 299.743a18.533 18.533 0 0 0 13.896-5.454c3.849-3.877 5.61-8.937 5.415-13.997l-19.311 19.451z" />
        </g>
        <g
          fill="#1A1C3A"
          stroke="#E3536C"
          strokeLinejoin="round"
          strokeWidth={0.8}
        >
          <path d="M102.187 280.292a18.533 18.533 0 0 1 13.896 5.454c3.85 3.877 5.61 8.937 5.415 13.997l-19.31-19.45zM121.433 299.743a18.533 18.533 0 0 1-13.896-5.454c-3.85-3.877-5.61-8.937-5.415-13.997l19.31 19.451z" />
        </g>
        <g
          fill="#1A1C3A"
          stroke="#E3536C"
          strokeLinejoin="round"
          strokeWidth={0.8}
        >
          <path d="M121.563 275.495c3.262 3.023 5.35 7.294 5.415 12.091.065 4.797-1.957 9.135-5.154 12.157l-.26-24.248zM121.759 299.678c-3.262-3.023-5.35-7.295-5.415-12.092-.065-4.797 1.957-9.134 5.154-12.157l.26 24.249z" />
        </g>
        <path
          d="M29.814 45.934c2.675-3.155 4.371-7.623 4.371-12.552 0-3.22-.717-6.242-1.957-8.805H8.285c-1.24 2.563-1.957 5.585-1.957 8.805 0 4.929 1.696 9.397 4.371 12.552h19.115z"
          fill="url(#dwarves__prefix__e)"
          transform="translate(101.6 275.232)"
        />
        <path
          d="M29.75 47.576H11.024a.867.867 0 0 1-.848-.854c0-.46.392-.854.848-.854H29.75c.457 0 .848.394.848.854 0 .526-.391.854-.848.854z"
          fill="url(#dwarves__prefix__f)"
          transform="translate(101.6 275.232)"
        />
      </g>
      <g transform="translate(272 98.54)">
        <path
          stroke="#E98699"
          strokeWidth={0.8}
          d="M1.93 14.925l12.088 11.964L34.606 6.576l9.165 9.072 13.814-13.74"
        />
        <ellipse
          fill="#E13F5E"
          fillRule="nonzero"
          cx={34.274}
          cy={7.172}
          rx={1.461}
          ry={1.446}
        />
        <ellipse
          fill="#E13F5E"
          fillRule="nonzero"
          cx={43.925}
          cy={14.806}
          rx={1.461}
          ry={1.446}
        />
        <ellipse
          fill="#E13F5E"
          fillRule="nonzero"
          cx={14.007}
          cy={27.211}
          rx={1.461}
          ry={1.446}
        />
        <ellipse
          fill="#E13F5E"
          fillRule="nonzero"
          cx={1.528}
          cy={13.917}
          rx={1.528}
          ry={1.512}
        />
        <path
          d="M56.068 1.325l2.192 2.498c.2.263.598.197.73-.132L60.12.536c.132-.329-.133-.592-.465-.526l-3.321.723c-.332 0-.465.329-.266.592z"
          fill="#E13F5E"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
